let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("kVX56"), load("8OOe7")]).then(() => parcelRequire('5UcAl'));